module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTStd-Bd.dd719c75.otf";